import type { FC } from 'react';
import { useCallback } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { submitDeviation } from '@wix/da-submit-shared/pkg/redux/actions/deviations';
import { updateDeviationEntity } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import InlinePriceEdit from '../InlinePriceEdit';
import { submitAdapter } from './adapters';

interface Props {
  deviation: PapiDeviation;
}

const PcpPriceEdit: FC<Props> = ({ deviation }) => {
  const dispatchSubmitDeviation = useAction(submitDeviation);
  const dispatchUpdateDeviationEntity = useAction(updateDeviationEntity);

  const onPriceUpdate = useCallback(
    (downloadDollarPrice: number, onSuccess: any, onError: any) => {
      if (!downloadDollarPrice) {
        return;
      }

      dispatchSubmitDeviation({
        contextId: 'studio-products-pcp',
        formData: submitAdapter(deviation, downloadDollarPrice),
        doPublish: false,
        doRedirect: false,
        onSuccess: () => {
          dispatchUpdateDeviationEntity({
            ...deviation,
            pcp: {
              ...deviation.pcp,
              downloadDollarPrice,
            },
          });
          onSuccess && onSuccess();
        },
        onError,
      });
    },
    [deviation, dispatchSubmitDeviation, dispatchUpdateDeviationEntity]
  );

  const dollarPrice = deviation.pcp?.downloadDollarPrice ?? 0;

  return (
    <InlinePriceEdit
      currentValue={dollarPrice}
      onSave={onPriceUpdate}
      forceInteger
    />
  );
};
PcpPriceEdit.displayName = 'PcpPriceEdit';

export default PcpPriceEdit;
